export default __webpack_public_path__ + "static/media/Stage2_rule.0756742d.png";